import sha1 from 'js-sha1';

export function getSha1Hash(data: string) {
  if (data === '' || data === '[]') {
    return '';
  }

  return sha1(data);
}
